import type { Drawing } from '@orgsim/shared';
import L from 'leaflet';
import { Marker, Polygon, Polyline } from 'react-leaflet';
import { escapeHtml } from '../signs/svg';
import { toLatLng } from './crs';

type Props = {
  drawings: Drawing[];
  onContextMenu?: (id: string, screen: { x: number; y: number }) => void;
};

export function DrawingLayer({ drawings, onContextMenu }: Props) {
  return (
    <>
      {drawings.map((d) => {
        const handlers = {
          contextmenu: (e: L.LeafletMouseEvent) =>
            onContextMenu?.(d.id, { x: e.originalEvent.clientX, y: e.originalEvent.clientY }),
        };
        if (d.kind === 'line') {
          return (
            <Polyline
              key={d.id}
              positions={d.points.map(toLatLng)}
              pathOptions={{ color: d.color, weight: 3 }}
              eventHandlers={handlers}
            />
          );
        }
        if (d.kind === 'polygon') {
          return (
            <Polygon
              key={d.id}
              positions={d.points.map(toLatLng)}
              pathOptions={{ color: d.color, weight: 2, fillOpacity: 0.2 }}
              eventHandlers={handlers}
            />
          );
        }
        // d.color and d.text come from the instructor's drawing tool (Task 6+), so both
        // must be escaped before landing in the style attribute and element content.
        const icon = L.divIcon({
          html: `<div style="color:${escapeHtml(d.color)};font:700 14px system-ui;text-shadow:0 0 3px #000;white-space:nowrap">${escapeHtml(d.text)}</div>`,
          iconSize: [0, 0],
        });
        return (
          <Marker key={d.id} position={toLatLng(d.position)} icon={icon} eventHandlers={handlers} />
        );
      })}
    </>
  );
}
